export var navBarHeight = "64px"
export var innerWrapperWidth = "85rem"